import { DEFAULT_TRANSLATE } from '../constants.js';

const useDragHandlers = ({
  useGeneric,
  activeId,
  setActiveId,
  setTransformState,
  getIndex,
  setIdArray,
  reorderIds
}) => {
  const handleGenericDragMove = ({
    delta
  }) => {
    setTransformState(({
      initialTranslate
    }) => ({
      initialTranslate,
      translate: {
        ...DEFAULT_TRANSLATE,
        x: initialTranslate.x + delta.x,
        y: initialTranslate.y + delta.y
      }
    }));
  };
  const handleDragEnd = over => {
    if (useGeneric) {
      setTransformState(({
        translate
      }) => ({
        initialTranslate: translate,
        translate
      }));
      return;
    }
    setActiveId(null);
    if (!over) return;
    const activeIndex = activeId ? getIndex(activeId) : -1;
    const overIndex = getIndex(over.id);
    if (activeIndex !== overIndex) {
      setIdArray(ids => reorderIds(ids, activeIndex, overIndex));
    }
  };
  return {
    onDragStart: useGeneric ? undefined : ({
      active
    }) => active && setActiveId(active.id),
    onDragEnd: ({
      over
    }) => handleDragEnd(over),
    onDragCancel: () => {
      if (useGeneric) {
        setTransformState(({
          initialTranslate
        }) => ({
          initialTranslate,
          translate: initialTranslate
        }));
      } else {
        setActiveId(null);
      }
    },
    onDragMove: useGeneric ? handleGenericDragMove : undefined
  };
};

export { useDragHandlers };
